'use client';

import {Scroller} from '@shared/Scroller/Scroller';

import {ArticleFeaturingCardType} from '@strapi/types/Articles';

import styles from './ArticleFeaturingCards.module.scss';
import FeaturingCard from './FeaturingCard';

type Props = {
  cards: Array<ArticleFeaturingCardType>;
  onFeaturingCardInArticleClick?: (index: number) => void;
};

export default function ArticleFeaturingCards({
  cards,
  onFeaturingCardInArticleClick,
}: Props) {
  return (
    <Scroller classes={{root: styles.root}} variant="grid">
      {cards.map((x, index) =>
        x.backgroundImage ? (
          <FeaturingCard
            key={x.id}
            featuring={x}
            index={index}
            onFeaturingCardInArticleClick={onFeaturingCardInArticleClick}
          />
        ) : null,
      )}
    </Scroller>
  );
}
